export default __webpack_public_path__ + "static/media/Group.61dbc25d.svg";